import type { ReactElement } from "react";

import type { SuiteName } from "../api/types";

const SUITE_LABELS: Record<SuiteName, string> = {
  Safety: "Safety Suite",
  Logistics: "Logistics Suite",
  Sales: "Sales Intelligence",
  Mining: "Mining Monitoring",
  Orchestration: "Orchestration",
  Industrial: "Industrial Workflow",
  Tooling: "Sales Tooling",
};

const SUITE_COLORS: Record<SuiteName, string> = {
  Safety: "#dc2626",
  Logistics: "#f59e0b",
  Sales: "#16a34a",
  Mining: "#0891b2",
  Orchestration: "#7c3aed",
  Industrial: "#6b7280",
  Tooling: "#0b5fff",
};

interface Props {
  suite: SuiteName;
  size?: "sm" | "md";
  className?: string;
}

export function SuiteBadge({ suite, size = "sm", className }: Props): ReactElement {
  const color = SUITE_COLORS[suite];
  return (
    <span
      className={`suite-badge suite-badge--${size} ${className ?? ""}`}
      style={{ backgroundColor: color, color: "white" }}
      title={SUITE_LABELS[suite]}
    >
      {SUITE_LABELS[suite]}
    </span>
  );
}

export { SUITE_LABELS, SUITE_COLORS };
